export default {
    bind: function(el, binding, vnode) {
        el.oninput = function () {
          if(this.timeout) clearTimeout(this.timeout);
          this.timeout = setTimeout(function () {
            setDescendantProp(vnode.context, vnode.data.ref, vnode.elm.value);
          }, binding.value)
        }
    }
};

function setDescendantProp(obj, desc, value) {
  var arr = desc.split(".");
  while(arr.length > 1 && (obj = obj[arr.shift()]));
  obj[arr[0]] = value;
}